import { render, staticRenderFns } from "./voucherHead.vue?vue&type=template&id=4b9bdd9e&scoped=true"
import script from "./voucherHead.vue?vue&type=script&lang=js"
export * from "./voucherHead.vue?vue&type=script&lang=js"
import style0 from "./voucherHead.vue?vue&type=style&index=0&id=4b9bdd9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9bdd9e",
  null
  
)

export default component.exports